import React from "react";
import styles from "./floating-butterflies.module.scss";
import Image from "next/image";
import butterflyOne from "@public/web-content/bless-butterfly-fragments/1.png";
import butterflyTwo from "@public/web-content/bless-butterfly-fragments/2.png";
import butterflyThree from "@public/web-content/bless-butterfly-fragments/3.png";

type Props = {};

const FloatingButterflies = (props: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.floater} style={{ right: 0, top: 0, width: "30%", animationDelay: "1s" }}>
        <Image src={butterflyTwo} alt="floating-butterfly" />
      </div>
      <div className={styles.floater} style={{ left: 0, top: "25%", width: "70%", animationDelay: "0.5s", animationDirection: "reverse" }}>
        <Image src={butterflyOne} alt="floating-butterfly" />
      </div>
      <div className={styles.floater} style={{ right: "5%", bottom: 0, width: "30%" }}>
        <Image src={butterflyThree} alt="floating-butterfly" />
      </div>
    </div>
  );
};

export default FloatingButterflies;
